import {
    AUTO_LOADING,
    AUTO_SWITCH,
    AUTO_GET_SUB_WALLET,
    AUTO_STOP_LOADING,
    AUTO_GET_BET_INFO,
    AUTO_GET_PLAYER_INFO,


    LAST_GET_AUTOBET_INFO_TS,
    LAST_GET_AUTOBET_INFO_STATUS,
    AUTO_SET_USER_WANT_STATUS,SET_AUTOBET_STATUS,
    CHECK_USER_PROCESS_AMOUNT
} from '../actions/types';

const initialState = {
    loading: false,

    autuBetStatus:0, //目前自動投注狀態

    autoBetInfo:{
        userID: "",
        gameID: "",
        gameType: "",
        contractAddress: "",
        currencyType: 0,
        subWalletID: "",
        address: "",
        privateKey: "",
        tokenContractAddress: "",
        amountAtBeginning: 0,
        rotateTime: 0,
        playerBet: 0,
        highLimit: 0,
        lowLimit: 0,
        winningInARowTimes: 0,
        winningSkipRounds: 0,
        losingInARowTimes: 0,
        losingSkipRounds: 0,
        status: 0,
        highPercentageCondition:105,
        lowPercentageCondition:95,
    },
    subWallet:null,
    // subWalletExist:null,
    // subWalletActive:null,
    playerInfo:{
        _id:0,
        modifiedTS:0,
        username:"",
        nickname: "",
        luckySeed: "",
        email:"",
    },

    //玩家開啟與關閉委託下注
    autoSwitchProcessing: false,
    userWantStatus:100, //啟動時希望停止:0 停止時希望啟動:100

    //
    getAutoBetInfoTS:0, //前端紀錄：取得自動下注狀態的TS
    getAutoBetInfoStatus:0, //前端紀錄：當下狀態

    isProcessAmountTX:false //用戶是否在對subWallet 做出入金的動作

};

export default function(state = initialState, action) {
  switch (action.type) {

      case CHECK_USER_PROCESS_AMOUNT:
          return {
              ...state,
              isProcessAmountTX: action.payload,
          };


      case AUTO_SET_USER_WANT_STATUS:
          return {
              ...state,
              userWantStatus: action.payload,
          };

      case AUTO_LOADING:
          return {
              ...state,
              loading: true
          };

      case AUTO_SWITCH:
          return {
              ...state,
              autoSwitchProcessing: action.payload,
          };

      case AUTO_STOP_LOADING:
          return {
              ...state,
              loading: false
          };

      case AUTO_GET_BET_INFO:
          return {
              ...state,
              autoBetInfo: action.payload,
              loading: false
          };


      case LAST_GET_AUTOBET_INFO_TS:
          return {
              ...state,
              getAutoBetInfoTS: action.payload,
          };


      case LAST_GET_AUTOBET_INFO_STATUS:
          return {
              ...state,
              getAutoBetInfoStatus: action.payload,
          };

      case AUTO_GET_PLAYER_INFO:
          return {
              ...state,
              playerInfo: action.payload,
              loading: false
          };


      case AUTO_GET_SUB_WALLET:
          return {
              ...state,
              subWallet: action.payload,
              loading: false
          };


      case SET_AUTOBET_STATUS:
          return {
              ...state,
              autuBetStatus: action.payload
          };

      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/autoReducer.js